export const CARDPOINTE_REFUND_MALFORMED_RESPONSE = 'CARDPOINTE_REFUND_MALFORMED_RESPONSE';

export const CardPointeRefundOutcome = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    MALFORMED_RESPONSE: 'malformed_response',
} as const;

export type CardPointeRefundOutcome =
    (typeof CardPointeRefundOutcome)[keyof typeof CardPointeRefundOutcome];

export interface CardPointeRefundRequestBody {
    readonly merchid: string;
    readonly retref: string;
    readonly amount?: string;
    readonly orderid?: string;
}

export interface CardPointeRefundRequestDetails {
    readonly method: 'POST';
    readonly path: '/cardconnect/rest/refund';
    readonly body: CardPointeRefundRequestBody;
}

export interface CardPointeRefundResponseBody {
    readonly respstat: 'A' | 'B' | 'C';
    readonly merchid?: string;
    readonly retref?: string;
    readonly amount?: string;
    readonly currency?: string;
    readonly orderid?: string;
    readonly respcode?: string;
    readonly respproc?: string;
    readonly resptext?: string;
    readonly receipt?: unknown;
    readonly receiptObj?: unknown;
    readonly declineCategory?: string;
    readonly declineCategoryText?: string;
    readonly fee_amount?: string;
    readonly fee_value?: string;
    readonly fee_type?: 'SURCHRG' | 'SURCHRG_WAIVED';
    readonly fee_format?: 'percent' | '';
    readonly fee_authcode?: string;
    readonly fee_merchid?: string;
    readonly fee_retref?: string;
}

export type CardPointeRefundResponseDetails =
    | {
          readonly outcome: typeof CardPointeRefundOutcome.APPROVED;
          readonly httpStatus: 200;
          readonly body: CardPointeRefundResponseBody & {
              readonly respstat: 'A';
              readonly retref: string;
              readonly merchid: string;
              readonly amount: string;
          };
      }
    | {
          readonly outcome: typeof CardPointeRefundOutcome.DECLINED;
          readonly httpStatus: 200;
          readonly body: CardPointeRefundResponseBody & {
              readonly respstat: 'B' | 'C';
              readonly resptext: string;
          };
      }
    | {
          readonly outcome: typeof CardPointeRefundOutcome.MALFORMED_RESPONSE;
          readonly httpStatus: number;
          readonly body: unknown;
          readonly message: string;
      };
